import $ from "jquery";
import { Loader } from "@googlemaps/js-api-loader";
import MarkerClusterer from "@googlemaps/markerclustererplus";
import { smoothscroll } from "./smoothscroll";

let listEl = $(".advisor-search");

let isMapInitialized = false;
let isACInitialized = false;
const center = { lat: 49.8175, lng: 15.473 };
let map;
let autocomplete;
let geocoder;
let location = false;
let markers = [];
let infowindows = [];
let currentMarkers = [];
let advisorMarkersInfo = [];
let locationMarker = false;
let markerCluster = null;
let data;
let enterReady = false;

let filter = {
    location: false,
    search: '',
    page: 1,
    firstPageCount: null
};

const loader = new Loader({
    apiKey: "AIzaSyDcrKy0_Xl4vw4R0gBMxfAxmQBH6XdtoEc",
    version: "weekly",
    libraries: ["places", "geometry"],
});

$(function () {
    listEl.each(function () {
        advisorSearch($(this));
    });
});

const initMap = async () => {
    if (!isMapInitialized) {
      isMapInitialized = true;
      
      if (listEl.length > 0) {
        loader.load().then(() => {
          map = new google.maps.Map(listEl.find(".advisor-results__map")[0], {
            zoom: 7,
            center: center,
          });
          
          if (location) {
            setLocationMarker();
          }
          
        });
      }
    }    
  }

const initAutocomplete = () => {
  if (!isACInitialized) {
    isACInitialized = true;
    
    if (listEl.length > 0) {
      loader.load().then(() => {
        autocomplete = new google.maps.places.Autocomplete(
          listEl.find("#advisor-search__form_input_text")[0],
          {
            fields: ["geometry", "name"],
            componentRestrictions: { country: "cz" },
            origin: center,
          }
        );
        geocoder = new google.maps.Geocoder();
        // listEl.each(function () {
        //   advisorSearch($(this));
        // });
        autocomplete.addListener('place_changed', () => {
          const place = autocomplete.getPlace();
          location = typeof place !== "undefined" ? place : false;
          // console.log('place changed');
          if (location.geometry) {
            enterReady = true;
            // console.log('warning hide in autocomplete listener');
            listEl.find("#location-missing-warning").hide();
            listEl.find("#advisor-search__form_input_text")
              .css("border-color", "#d6d6d6");
          }
        });
        
      });
    }

  }    
}

const advisorSearch = (listEl) => {  
    if (isMapInitialized) {    
      reRenderList(listEl, filter);
    } else {
      bindAdvisorSearchButtons(listEl, filter);
    }
};

const reRenderList = async (element, filter, append = false) => {  
    data = await getAdvisors(filter);  
    
    if (append === true) {
      element.find("#advisor-results").append(data.html);
      
    } else {
      isMapInitialized = false;

      element.find("#advisor-results").html('');
      element.find("#advisor-results").html(data.html);
      
      element.off('click', '.advisor-list__rowName_show');
      element.on('click', '.advisor-list__rowName_show', function () {
        let parent = $(this).parents('.advisor-list__row_wrapper');
        let parentRow = $(this).parents('.advisor-list__row');
        let content = $(parent).find('.advisor-list__advisors');
        
        if ($(content).hasClass('active')) {
          $(this).removeClass('active');
          $(this).html('zobrazit poradce ▼');
          $(content).removeClass('active');
          $(parentRow).removeClass('active');
        } else {
          $(this).addClass('active');
          $(this).html('skrýt poradce ▲');
          $(content).addClass('active');
          $(parentRow).addClass('active');
        }
      });
    }
};

const bindAdvisorSearchButtons = (element, filter) => {
    element.on("click", ".advisor-search__buttonSearch", function (event) {
      if (location !== false) {
        smoothscroll(event, this);

        filter.page = 1;
        filter.location = location
          ? {
              lat: location.geometry.location.lat(),
              lng: location.geometry.location.lng(),
            }
          : false;
        reRenderList(element, filter);

        enterReady = false;
      } else {
        element.find("#advisor-search__form_input_text").blur();
        element.find("#advisor-search__form_input_text").focus();
        element.find("#advisor-search__form_input_text").css("border-color", "red");
        // console.log('warning show in button search click');
        element.find("#location-missing-warning").show();
      }
    });

    $(document).on("keypress", function (event) {
      if (event.key === 'Enter') {
        if (enterReady) {
          filter.page = 1;
          filter.location = location
            ? {
                lat: location.geometry.location.lat(),
                lng: location.geometry.location.lng(),
              }
            : false;
          reRenderList(element, filter);

          enterReady = false;

          $('html, body')
          .stop()
          .animate(
              {
                  // scrollTop: $(".advisor-search__buttonSearch").offset().top - 100,
                  scrollTop: $("#advisor-results").offset().top - 100,
              },
              1000,
              function () {
                $(window).trigger('smoothscroll:end');
              }
          );
        } else {
          element.find("#advisor-search__form_input_text").css("border-color", "red");
          element.find("#location-missing-warning").show();
        }
      }
    });
  
    element.on("click", ".advisor-search__buttonReset", function () {
      filter.page = 1;
      filter.location = false;
    
      location = false;
      element.find("#advisor-search__form_input_text").val("");
      element.find("#advisor-search__form_input_text").removeAttr("style");
      // console.log('warning hide in button reset click');
      element.find("#location-missing-warning").hide();
      
      // reRenderList(element, filter);
      element.find("#advisor-results").html('');
      isMapInitialized = false;
    });
  
    element.on("click", ".advisor-search__buttonLocation", function () {
      initAutocomplete();
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(handleUserLocation);
      } else {
        alert("Geolocation is not supported by this browser.");
      }
    });
  
    element.on("keydown", "#advisor-search__form_input_text", function () {
      if (this.value.length > 0) {
        initAutocomplete();
      }
    });

    element.on("change", "#advisor-search__form_input_text", function () {
    
      location = false;
      if ($(this).val().trim()) {
        // $(this).css("border-color", "red");
        // console.log('warning show in input text change');
        // element.find("#location-missing-warning").show();
        element.find("#advisor-search__form_input_text").blur();
        element.find("#advisor-search__form_input_text").focus();
      } else {
        $(this).css("border-color", "#d6d6d6");
      }
    });
    
    element.off('click', '.advisor-results__show-map');
    element.on('click', '.advisor-results__show-map', async function () {
      let parent = $(this).parent();
      let content = $(parent).find('.advisor-results__map');
      let contentParagraphHeight = $($(content).children().get(0)).outerHeight();
      
      if ($(content).hasClass('active')) {
          $(this).removeClass('active');
          $(this).html('zobrazit výsledky na mapě ▼');
          $(content).removeClass('active');
          $(content).css('max-height', 0);
      } else {
          if (!isMapInitialized) {
            await initMap();          
            await updateMap(data.advisors, data.countToShow);
          }

          $(this).addClass('active');
          $(this).html('skrýt výsledky na mapě ▲');
          $(content).addClass('active');
          $(content).css('max-height', contentParagraphHeight);
      }
  });

  element.on("click", ".advisor-list__more_button", function () {
    filter.page++;
    reRenderList(element, filter, true);
    $(this).parent().remove();
  });
}

const getAdvisors = async (filter) => {
    try {
      const response = await fetch(
        SITE_PARAMS.site_url + `/wp-json/nzu/v1/advisor-subject/html`,
        {
          method: "POST",
          headers: new Headers({
            "Content-Type": "application/json",
          }),
          body: JSON.stringify(filter),
        }
      );
      const result = await response.json();
      return result;
    } catch (e) {
      console.log(e);
      return null;
    }
};

const handleUserLocation = async (locationResult) => {
    const latLng = {
        lat: locationResult.coords.latitude,
        lng: locationResult.coords.longitude,
    };
    geocoder.geocode({ location: latLng }, (results, status) => {
        if (status === "OK") {
          location = results[0];
          $("#advisor-search__form_input_text").val(location.formatted_address);
          // setLocationMarker(location.formatted_address);
        }
    });
};

const setLocationMarker = () => {
  if (locationMarker) {
    locationMarker.setMap(null);
    locationMarker = false;
  }
  if (location) {
    const contentString =
      '<div class="marker-popup">' +
      '<h4 class="marker-popup__header">Zadaná adresa</h4>' +
      '<div class="marker-popup__text">' +
      '<p class="marker-popup__text__location">' +
      location.formatted_address +
      "</p>" +
      "</div>" +
      "</div>";
    const infowindow = new google.maps.InfoWindow({
      content: contentString,
    });
    const latLng = {
      lat: location.geometry.location.lat(),
      lng: location.geometry.location.lng(),
    };
    const marker = new google.maps.Marker({
      map,
      position: latLng,
      clickable: true,
      icon: {
        url: "https://maps.google.com/mapfiles/ms/icons/red-dot.png",
      },
    });
    marker.setAnimation(google.maps.Animation.BOUNCE);
    setTimeout(function () {
      marker.setAnimation(null);
    }, 1400);
    marker.addListener("click", () => {
      $.each(infowindows, (key, infowin) => {
        infowin.close();
      });
      infowindow.open(map, marker);
    });
    locationMarker = marker;
    map.setCenter(latLng);
    map.setZoom(11);
  }
};

const updateMap = async (data, countToShow) => {
    if (markerCluster) {
      markerCluster.clearMarkers();
    }
  
    advisorMarkersInfo = [];
    $.each(markers, (key, marker) => {
      marker.setMap(null);
    });
    $.each(infowindows, (key, infowin) => {
      infowin.close();
    });
    markers = [];
    $.each(data, function (key, advisor) {
      
      let title = advisor.name;
      
      advisorMarkersInfo[advisor.id] = [];
        const contentString = 
          '<div class="marker-popup">' +
          '<h4 class="marker-popup__header">' +
          title +
          "</h4>" +
          '<div class="marker-popup__text">' +
          '<p class="marker-popup__text__location">' +
          advisor.address +
          "</p>" +
          '<p class="marker-popup__text__people"><a class="smoothscroll" ' +
          'data-selector="#advisor' + advisor.id + '" data-animduration="1000" data-offset="100">Zobrazit poradce</a></p>' +
          "</div>" +
          "</div>";
        const infowindow = new google.maps.InfoWindow({
          content: contentString,
        });
        const marker = new google.maps.Marker({
          map,
          position: { lat: advisor.lat, lng: advisor.lng },
          title: title,
          clickable: true,
          icon: {
            url: "https://maps.google.com/mapfiles/ms/icons/green-dot.png",
          },
        });
        
        marker.addListener("click", () => {
          $.each(infowindows, (key, infowin) => {
            infowin.close();
          });
          infowindow.open(map, marker);
        });
        markers.push(marker);
        infowindows.push(infowindow);
        advisorMarkersInfo[advisor.id].push({
          lat: advisor.lat,
          lng: advisor.lng,
        });
    });
    
    if (markers.length && countToShow > 0) {
      if (markers.length == 1){
        map.setCenter(markers[0].position);
        map.setZoom(12);
      } else {
        var bounds = new google.maps.LatLngBounds();
        let markersToShow = markers.slice(0, countToShow);
        
        $.each(markersToShow, (key, marker) => {
          bounds.extend(marker.position);
        });
        bounds.extend(locationMarker.position);
        map.fitBounds(bounds, 5);
        markerCluster = new MarkerClusterer(map, markers, {
          minimumClusterSize: 5,
          imagePath:
            "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m",
        });
      }
    } else {
      if (map !== undefined) {
        map.setCenter(center);
        map.setZoom(7);
      }
    }
  };